var map = {
	"./api-product/api-product.module": [
		"./src/app/pages/products/detail-product/api-product/api-product.module.ts",
		"default~api-product-api-product-module~detail-product-detail-product-module~pages-products-products-~ccc23b8a",
		"default~api-product-api-product-module~detail-product-detail-product-module~pages-test-api-test-api-~cd2dc688",
		"default~api-product-api-product-module~detail-product-detail-product-module",
		"common"
	],
	"./detail-product/detail-product.module": [
		"./src/app/pages/products/detail-product/detail-product.module.ts",
		"default~api-product-api-product-module~detail-product-detail-product-module~pages-products-products-~ccc23b8a",
		"default~api-product-api-product-module~detail-product-detail-product-module~pages-test-api-test-api-~cd2dc688",
		"default~api-product-api-product-module~detail-product-detail-product-module",
		"common",
		"detail-product-detail-product-module"
	],
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"default~pages-home-home-module~pages-test-api-test-api-module",
		"common",
		"pages-home-home-module"
	],
	"./pages/not-found/not-found.module": [
		"./src/app/pages/not-found/not-found.module.ts",
		"pages-not-found-not-found-module"
	],
	"./pages/products/products.module": [
		"./src/app/pages/products/products.module.ts",
		"default~api-product-api-product-module~detail-product-detail-product-module~pages-products-products-~ccc23b8a",
		"common",
		"pages-products-products-module"
	],
	"./pages/test-api/test-api.module": [
		"./src/app/pages/test-api/test-api.module.ts",
		"default~api-product-api-product-module~detail-product-detail-product-module~pages-test-api-test-api-~cd2dc688",
		"default~pages-home-home-module~pages-test-api-test-api-module",
		"common",
		"pages-test-api-test-api-module"
	],
	"./sdk-product/sdk-product.module": [
		"./src/app/pages/products/detail-product/api-product/sdk-product/sdk-product.module.ts",
		"default~api-product-api-product-module~detail-product-detail-product-module~pages-products-products-~ccc23b8a",
		"common",
		"sdk-product-sdk-product-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;